import { IonContent, IonPage } from '@ionic/react';

export default function Main() {
	return (
		<IonPage>
			<IonContent fullscreen scrollY={false}>
				<div className='w-full h-full justify-items-center items-start flex flex-col bg-c-purple'>
					<img src={`/assets/media/tela-1-mobile.png`} alt='' className='w-full object-contain mt-4' />
				</div>
				<p className='absolute bottom-8 px-16 text-center text-sm font-bar uppercase border-t pt-4 text-yellow-500'>
					Aponte sua câmera para o QRCode na tela e siga as instruções
				</p>
			</IonContent>
		</IonPage>
	);
}
